import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE05003S = () => {

  return (
	<CommonLayout>
      <CommonMenu />
		<>
            <div id="contents" className="container">
                <div className="sub-title bg-type05">
                    <h2>개인정보처리방침</h2>
                </div>

                <div id="cont" className="cont">
                    <div className="inner">

                        {/* 탭 메뉴 */}
                        <div className="tabs ty02">
                            <ul className="tab-item col03">
                                <li>
                                    <Link to="/GNBPURE05001S">개인정보처리방침</Link>
                                </li>
                                <li>
                                    <Link to="/GNBPURE05002S">이용약관</Link>
                                </li>
                                <li className="on">
                                    <Link to="/GNBPURE05003S">이메일 무단수집공고</Link>
                                </li>
                            </ul>
                        </div>


                        {/* 이메일 무단수집공고 */}
                            <div className="notice active">

                                <h1 className="contTitle">이메일 무단수집공고</h1>

                                <div className="cont-wrap">
                                    <div id="sub_contents" className="container-fluid no-padding">
                                        <div className="sub_menu_nav_wrap clearfix"></div>
                                        <div className="container sub_contents_area">
                                            <div className="privacy clearfix">
                                                <div className="row">
                                                    <p>
                                                        본 웹사이트는 일반적인 정보를 제공할 목적으로 제작된 것으로서 특정사안에 대한 법적근거로 사용할 수 없으며 본 웹사이트에서
                                                        취득한 정보에 의하여 어떠한 결과를 얻었다고 하더라도 (주)지앤비소프텍은 이에 대한 책임을 지지 않으며, 본 웹사이트의 정보들에
                                                        근거하여 법적조치를 취하실 경우 반드시 법률자문을 구하여야 합니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">
                                                        &lt;정보통신망 이용촉진 및 정보보호 등에 관한 법률&gt;
                                                    </p>
                                    
                                                    <p>
                                                        <strong>제50조의2 (전자우편주소의 무단 수집행위 등 금지)</strong>
                                                        <br />
                                                        1. 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램
                                                        그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.
                                                        <br />
                                                        2. 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매ㆍ유통하여서는 아니된다.
                                                        <br />
                                                        3. 누구든지 제1항 및 제2항의 규정에 의하여 수집ㆍ판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는
                                                        아니된다.
                                                    </p>
                                    
                                                    <p>
                                                        <strong>제74조 (벌칙) 다음 각호의 1에 해당하는 자는 1천만원 이하의 벌금에 처한다.</strong>
                                                        <br />
                                                        1. 제8조제4항의 규정을 위반하여 표시ㆍ판매 또는 판매할 목적으로 진열한 자
                                                        <br />
                                                        2. 제44조의7제1항제1호의 규정을 위반하여 음란한 부호ㆍ문언ㆍ음향ㆍ화상 또는 영상을 배포ㆍ판매ㆍ임대하거나 공연히 전시한 자
                                                        <br />
                                                        3. 제44조의7제1항제3호의 규정을 위반하여 공포심이나 불안감을 유발하는 부호ㆍ문언ㆍ음향ㆍ화상 또는 영상을 반복적으로
                                                        상대방에게 도달하게 한 자
                                                        <br />
                                                        4. 제50조제6항의 규정을 위반하여 기술적 조치를 한 자
                                                        <br />
                                                        5. 제50조의8의 규정을 위반하여 광고성 정보를 전송한 자
                                                        <br />
                                                        6. 제50조의2의 규정을 위반하여 전자우편 주소를 수집ㆍ판매ㆍ유통 또는 정보전송에 이용한 자
                                                        <br />
                                                        7. 제50조의8의 규정을 위반하여 광고성 정보를 전송한 자
                                                        <br />
                                                        8. 제53조제4항을 위반하여 등록사항의 변경등록 또는 사업의 양도ㆍ양수 또는 합병ㆍ상속의 신고를 하지 아니한 자
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>       
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE05003S;
